import {rasterTrafficIncidentTilesLayer} from '../../endpoints';
import rasterStylesFactory from './rasterStylesFactory';

const LAYER_NAMES = {
    S0: 'tomtomRasterTrafficIncidentsS0',
    S0_DARK: 'tomtomRasterTrafficIncidentsS0Dark',
    S1: 'tomtomRasterTrafficIncidentsS1',
    S2: 'tomtomRasterTrafficIncidentsS2',
    S3: 'tomtomRasterTrafficIncidentsS3',
    NIGHT: 'tomtomRasterTrafficIncidentsNight'
};

const S0 = rasterStylesFactory('raster-traffic-incidents', LAYER_NAMES.S0_DARK, rasterTrafficIncidentTilesLayer, {
    '{style}': 's0-dark',
    '{tileSize}': 512
});

const S0_DARK = rasterStylesFactory('raster-traffic-incidents', LAYER_NAMES.S0_DARK, rasterTrafficIncidentTilesLayer, {
    '{style}': 's0-dark',
    '{tileSize}': 512
});

const S1 = rasterStylesFactory('raster-traffic-incidents', LAYER_NAMES.S1, rasterTrafficIncidentTilesLayer, {
    '{style}': 's1',
    '{tileSize}': 512
});

const S2 = rasterStylesFactory('raster-traffic-incidents', LAYER_NAMES.S2, rasterTrafficIncidentTilesLayer, {
    '{style}': 's2',
    '{tileSize}': 512
});

const S3 = rasterStylesFactory('raster-traffic-incidents', LAYER_NAMES.S3, rasterTrafficIncidentTilesLayer, {
    '{style}': 's3',
    '{tileSize}': 512
});

const NIGHT = rasterStylesFactory('raster-traffic-incidents', LAYER_NAMES.NIGHT, rasterTrafficIncidentTilesLayer, {
    '{style}': 'night',
    '{tileSize}': 512
});

const STYLES = {
    S0,
    S0_DARK,
    S1,
    S2,
    S3,
    NIGHT
};

export default function(style) {
    return JSON.parse(JSON.stringify(STYLES[style.toUpperCase().replace('-', '_')]));
}



// WEBPACK FOOTER //
// ./map/tier/styleParts/rasterTrafficIncidentTiles.js